import { COLORS } from '../theme';

export default {
  styleOverrides: {
    root: {
      '&:has(.MuiSwitch-switchBase)': {
        color: COLORS.black60,
      },

      '&:has(.MuiSwitch-switchBase.Mui-checked)': {
        color: 'inherit',
      },

      '.MuiFormControlLabel-label': {
        fontWeight: 500,
      },
    },
  },
};
